import { Tag, CheckPicker } from "rsuite";
import PropTypes from "prop-types";
import SoldOutBadge from "./SoldOutBadge";
import TruncatedText from "../common/TruncatedText";

const TabsFilter = ({ rooms, ariData, filteredRooms, setFilteredRooms }) => {
  const clearRoomFilter = () => {
    setFilteredRooms([]);
  };

  const handleRoomSelect = (values) => {
    // Maintain original room order by filtering from the original rooms array
    const orderedFilteredRooms = rooms.filter((room) =>
      values.includes(room.id)
    );
    setFilteredRooms(orderedFilteredRooms);
  };

  const renderValue = (values) => {
    return <Tag>{`Showing ${values.length}/${rooms.length} rooms`}</Tag>;
  };

  const renderMenuItem = (label, item) => {
    const isSoldOut = ariData?.some(
      ({ roomtypeId, inventory }) => roomtypeId === item.id && !inventory
    );
    return (
      <div className="room-type__menu-item">
        <TruncatedText text={label} className="room-type__menu-item-label" />
        <SoldOutBadge isSoldOut={isSoldOut} />
      </div>
    );
  };

  return (
    <CheckPicker
      block
      data={rooms}
      labelKey="displayName"
      valueKey="id"
      className="roomtype-picker"
      value={filteredRooms.map(({ id }) => id)}
      onSelect={handleRoomSelect}
      onClean={clearRoomFilter}
      placeholder="Filter room types"
      renderValue={renderValue}
      renderMenuItem={renderMenuItem}
    />
  );
};

TabsFilter.propTypes = {
  rooms: PropTypes.array.isRequired,
  ariData: PropTypes.arrayOf(
    PropTypes.shape({
      roomtypeId: PropTypes.number.isRequired,
      inventory: PropTypes.number.isRequired,
    })
  ),
  filteredRooms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  setFilteredRooms: PropTypes.func.isRequired,
};

export default TabsFilter;
